import { FunctionWithNoArgs } from './hookUtilityTypes';
import { useEffect } from 'react';
import { useTimeout } from './useTimeout';

/**
 * Invoke a callback when dependencies remain unchanged for a period of time
 * @param callback called after the dependencies are stable
 * @param delay the delay before calling the callback
 * @param dependencies the dependencies to monitor
 */
export default function useDebounce(callback: FunctionWithNoArgs, delay: number, dependencies: any[]): void {
  const { reset, clear } = useTimeout(callback, delay);
  useEffect(reset, [...dependencies, reset]);

  // Ensure tha the callback will only be called after the first change
  useEffect(clear, []);
}
